import { FaqSubItemType, FaqTopic } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/faq.type';
import { removeAccentuation } from '@/utils/formatters/remove-accentuations';

function normalize(text: string): string {
  return removeAccentuation(text).toLowerCase();
}

function matches(item: FaqSubItemType, normalizedQuery: string): boolean {
  const haystack = normalize(`${item.title} ${item.description ?? ''}`);
  return haystack.includes(normalizedQuery);
}

function filterItem(item: FaqSubItemType, normalizedQuery: string): FaqSubItemType | null {
  if (matches(item, normalizedQuery)) {
    return item;
  }

  const filteredKids = (item.subitems ?? [])
    .map((child) => filterItem(child, normalizedQuery))
    .filter((c): c is FaqSubItemType => c != null);

  if (filteredKids.length === 0) {
    return null;
  }

  return { ...item, subitems: filteredKids };
}

export interface FilteredFaqContent {
  filtered: FaqTopic[];
  expandedTopics: string[];
}

export function filterFaqContent(content: FaqTopic[], rawQuery: string): FilteredFaqContent {
  const normalizedQuery = normalize(rawQuery.trim());

  if (!normalizedQuery) {
    return { filtered: content, expandedTopics: [] };
  }

  const filtered = content
    .map((topic) => ({
      ...topic,
      subitems: topic.subitems
        .map((item) => filterItem(item, normalizedQuery))
        .filter((i): i is FaqSubItemType => i != null),
    }))
    .filter((topic) => topic.subitems.length > 0);

  return {
    filtered,
    expandedTopics: filtered.map((t) => t.title),
  };
}
